import {createUseMutation, createUseQuery} from "@irati/utils/services/apollo"
import {
  CelebrationTag,
  GroupCelebration,
  MutationPublishPollArgs,
  Poll,
  QueryCelebrationTagArgs,
  QueryCelebrationTagsArgs,
  QueryGroupCelebrationArgs,
  RecognitionMessageTemplate
} from "@irati/types"
import GroupCelebrationQuery from "@irati/recognition/apollo/query/GroupCelebration"
import RecognitionMessageTemplatesQuery, {
  recognitionMessageTemplatesQueryKey
} from "@irati/recognition/apollo/query/RecognitionMessageTemplate"
import PublishPollMutation, {publishPollMutationKey} from "@irati/recognition/services/mutations/PublishPoll"
import CelebrationTagsQuery from "@irati/recognition/services/queries/CelebrationTags"
import CelebrationTagQuery from "@irati/recognition/services/queries/CelebrationTag"

export const useScheduledGroupCelebrationQuery = createUseQuery<GroupCelebration, QueryGroupCelebrationArgs>(GroupCelebrationQuery, {
  key: "groupCelebration"
})
export const useRecognitionMessageTemplates = createUseQuery<RecognitionMessageTemplate[], null>(RecognitionMessageTemplatesQuery, {
  key: recognitionMessageTemplatesQueryKey
})
export const useCelebrationTagsQuery = createUseQuery<CelebrationTag[], QueryCelebrationTagsArgs>(CelebrationTagsQuery, {
  key: "celebrationTags"
})
export const useCelebrationTagQuery = createUseQuery<CelebrationTag, QueryCelebrationTagArgs>(CelebrationTagQuery, {
  key: "celebrationTag"
})
export const usePublishPollMutation = createUseMutation<Poll, MutationPublishPollArgs>(PublishPollMutation, {
  key: publishPollMutationKey
})

export {useRecognitionNudge} from "./useRecognitionNudge"
